"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderList = void 0;
const Base_1 = require("./Base");
exports.GetOrderList = {
    url: Base_1.URL_BASE + "/GetOrderList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetOrderList.js.map